import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  AcceptAgentAccountAPI,
  ConvertAgentToUserAccountAPI,
  CreateAgentAPI,
  ListAgentsAPI,
  ListAllAgentsAPI,
  RejectAgentAccountAPI,
  UpdateAgentsAPI,
} from "./agents.api";

export const agentsKeys = {
  all: ["agents"],
  lists: () => [...agentsKeys.all, "list"],
  list: (params) => [...agentsKeys.lists(), params],
};

export const useAgentsListQuery = (params) =>
  useQuery({
    queryKey: agentsKeys.list(params),
    queryFn: () => ListAgentsAPI(params),
  });

export const useAllAgentsExportMutation = () =>
  useMutation({
    mutationFn: ListAllAgentsAPI,
  });

export const useCreateAgentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: CreateAgentAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: agentsKeys.lists() });
    },
  });
};

export const useUpdateAgentsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UpdateAgentsAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: agentsKeys.lists() });
    },
  });
};

export const useRejectAgentAccountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: RejectAgentAccountAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: agentsKeys.lists() });
    },
  });
};

export const useAcceptAgentAccountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: AcceptAgentAccountAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: agentsKeys.lists() });
    },
  });
};

export const useConvertAgentToUserAccountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ConvertAgentToUserAccountAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: agentsKeys.lists() });
      queryClient.invalidateQueries({ queryKey: ["users", "list"] });
    },
  });
};
